import { render } from "./ClinicalDiagnosis.vue?vue&type=template&id=9821f00e&ts=true"
import script from "./ClinicalDiagnosis.ts?vue&type=script&lang=ts&external"
export * from "./ClinicalDiagnosis.ts?vue&type=script&lang=ts&external"

import "./ClinicalDiagnosis.vue?vue&type=style&index=0&id=9821f00e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__